var exports = {
  "hS": "ForwardModal.module__richInput___dGFEVj",
  "NG": "ForwardModal.module__footerSection___dGFEVj",
  "vm": "ForwardModal.module__messageInputContainer___dGFEVj",
  "hj": "ForwardModal.module__messageInputContainerDisabled___dGFEVj",
  "zt": "ForwardModal.module__messageInputContainerWithCounter___dGFEVj",
  "pn": "ForwardModal.module__messageInputContainerWithNotice___dGFEVj",
  "XK": "ForwardModal.module__slowmodeNotice___dGFEVj",
  "X8": "ForwardModal.module__messageInputActions___dGFEVj",
  "Vr": "ForwardModal.module__emojiPickerButton___dGFEVj",
  "Z8": "ForwardModal.module__emojiPickerButtonActive___dGFEVj",
  "mI": "ForwardModal.module__emojiIcon___dGFEVj",
};

module.exports = exports;
